import { Link } from 'react-router-dom';
import { MapPin, Bed, Bath, ArrowRight } from 'lucide-react';
import './PropertyCard.css';

const PropertyCard = ({ property }) => {
    return (
        <Link to={`/property/${property.id}`} className="property-card">
            <div className="property-card-image-wrapper">
                <img
                    src={property.image_url || 'https://via.placeholder.com/400x300'}
                    alt={property.title}
                    className="property-card-image"
                />
                <div className="property-card-overlay">
                    <div className="property-card-view-btn">
                        View Details <ArrowRight size={16} />
                    </div>
                </div>
                <div className="property-card-badge badge badge-primary">
                    {property.type}
                </div>
                <div className="property-card-price">
                    ₹{property.price}/mo
                </div>
            </div>

            <div className="property-card-content">
                <h3 className="property-card-title">{property.title}</h3>
                <div className="property-card-location">
                    <MapPin size={16} />
                    {property.location}
                </div>

                {(property.bedrooms || property.bathrooms) && (
                    <div className="property-card-features">
                        {property.bedrooms && (
                            <div className="property-card-feature">
                                <Bed size={18} />
                                <span>{property.bedrooms} Beds</span>
                            </div>
                        )}
                        {property.bathrooms && (
                            <div className="property-card-feature">
                                <Bath size={18} />
                                <span>{property.bathrooms} Baths</span>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </Link>
    );
};

export default PropertyCard;
